import {ISkeleton} from '../../interfaces/skeleton';
import {SkeletonTypeEnum} from '../../enums/skeleton';

export const UtilityPanelProfileSkeleton: ISkeleton[] = [
  {
    multiple: true,
    style: 'width: 100%',
    classes: 'mt-md',
    items: [
      {
        type: SkeletonTypeEnum.IMAGE,
        classes: 'mr-sm rounded-image',
        style: 'width: 90px; height: 90px',
      },
      {
        type: SkeletonTypeEnum.TEXT,
        style: 'width: 200px;',
        rows: 1,
      },
    ],
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    style: 'width: 100%; height: 70px',
    classes: 'mt-sm',
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.TEXT,
    style: 'width: 100%',
    rows: 3,
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.TEXT,
    style: 'width: 100%',
    rows: 0,
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    style: 'width: 100%; height: 50px;',
    classes: 'mb-sm',
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    style: 'width: 100%; height: 50px;',
    classes: 'mb-sm',
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    style: 'width: 100%; height: 50px;',
    classes: 'mb-sm',
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    style: 'width: 100%; height: 50px;',
    classes: 'mb-sm',
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    style: 'width: 100%; height: 50px;',
    classes: 'mb-sm',
  },
];
